import React from 'react'
import { AppProvidersAutocomplete } from '@components'
import { useAppFormHandler } from '@hooks'


export default function ProvidersSelector() {

	const { idProviders, onIdProvidersChange } = useAppFormHandler('idProviders')

	return <AppProvidersAutocomplete
		value={idProviders}
		onChange={e => onIdProvidersChange(e.target.value)}
	/>
}